<template>
	<div class="main-containter" v-title data-title="reservaion">
		<PHeader :checkId="'专业人员26'"  :activeNames="'专业人员'"></PHeader>
		
		<article>
			<div style="margin-top:10px;margin-left:3%;">
				<span style="color:#AAAAAA;font-size:14px;">首页 / 专业人员</span>
				<span style="color:#333333;font-size:14px;"> / 人员详情</span>
			</div>
			<div style="width:94%;margin-left:3%;margin-bottom:20px;margin-top:20px;">
				<div style="width: 100%;height: 200px;">
					<div style="float:left;width:36%;height:100%;">
						<img :src="item.image" style="height:96%;padding-top:2%;width:100%;">
					</div>
					<div style="float: left;width: 61%;margin-left: 3%;margin-top: 30px;line-height: 30px;font-size: 14px;">
						<div>
							<span style="color: #AC273A;font-size: 20px;">{{item.name}}</span>
							<span> /{{item.relationship_name}}</span>
						</div>
						<div>
							邮件：{{item.email}}
						</div>
						<div>
							电话：{{item.phone}}
						</div>
						<div>
							地址：{{item.company_address}}
						</div>
					</div>
				</div>
				<div style="color: rgb(172, 39, 58);font-size: 20px;margin-top: 15px;">
					执业领域
				</div>
				<div style="margin-top: 15px;font-size: 16px;color: #333333;line-height: 26px;padding-bottom: 15px;border-bottom: 1px solid #E5E5E5;">
					{{item.practice_areas}}
				</div>
				<div style="color: rgb(172, 39, 58);font-size: 20px;margin-top: 15px;">
					执业经验
				</div>
				<div style="margin-top: 15px;font-size: 16px;color: #333333;line-height: 26px;padding-bottom: 15px;border-bottom: 1px solid #E5E5E5;">
					{{item.practicing_experience}}
				</div>
				<div style="color: rgb(172, 39, 58);font-size: 20px;margin-top: 15px;">
					教育背景
				</div>
				<div style="margin-top: 15px;font-size: 16px;color: #333333;line-height: 26px;padding-bottom: 15px;border-bottom: 1px solid #E5E5E5;">
					{{item.educational_background}}
				</div>
				<div style="color: rgb(172, 39, 58);font-size: 20px;margin-top: 15px;">
					工作经历
				</div>
				<div style="margin-top: 15px;font-size: 16px;color: #333333;line-height: 26px;padding-bottom: 15px;border-bottom: 1px solid #E5E5E5;">
					{{item.work_experience}}
				</div>
				<div style="color: rgb(172, 39, 58);font-size: 20px;margin-top: 15px;">
					社会职务
				</div>
				<div style="margin-top: 15px;font-size: 16px;color: #333333;line-height: 26px;padding-bottom: 15px;border-bottom: 1px solid #E5E5E5;">
					{{item.social_position}}
				</div>
				<div style="color: rgb(172, 39, 58);font-size: 20px;margin-top: 15px;">
					工作语言
				</div>
				<div style="margin-top: 15px;font-size: 16px;color: #333333;line-height: 26px;padding-bottom: 15px;border-bottom: 1px solid #E5E5E5;">
					{{item.working_language}}
				</div>
			</div>
		</article>
		<Pooter></Pooter>
	</div>
</template>

<script>
	import PHeader from "../../components/p/PHeader.vue"
	import Pooter from "../../components/p/Pooter.vue"
	import {queryDetail} from "@/api/lawyer";
	export default {
		name: "Index",
		components: {
			PHeader,
			Pooter
		},
		data() {
			return {
				id: 0,
				item: {},
			}
		},
		created() {
			this.id = this.$route.query.id
			this.queryDetail()
		},
		mounted() {
			this.id = this.$route.query.id
			this.queryDetail()
		},
		activated() {
			this.id = this.$route.query.id
			this.queryDetail()
		},
		methods: {
			queryDetail(){
				let param = {}
				param.id = this.id
				queryDetail(param).then(data => {
						this.item = data.data
					}).catch(error => {
						this.$message.error(error)
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.indexAboutUs{
		background: url("https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/phoneBusiness.png") no-repeat;
		height:100%;
		width:100%;
		overflow: hidden;
		background-size:cover;//或者background-size:1
	}
	.main-containter {
		.news{
			background-image: url(../../assets/fImage/homeNewsBg.jpg);
			background-size: cover;
		}
	}
	.main-containter ::v-deep .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel ::v-deep .el-carousel__container{
		height: 100%;
	}
	body ::v-deep .v-modal{
		display: none;
	}
</style>
